import React from "react"

export interface DashboardLayoutDialogFooterProps {
  onCancel: () => void
  children: React.ReactNode
}

/** Cancel + primary action grouped together (matches standard form dialog footers). */
export function DashboardLayoutDialogFooter({
  onCancel,
  children,
}: DashboardLayoutDialogFooterProps): React.ReactElement {
  return (
    <div data-dashboard-layout-dialog-footer="" className="flex items-center gap-2">
      <button type="button" data-strategy-pine-detail-cancel="" data-font="primary" onClick={onCancel}>
        Cancel
      </button>
      {children}
    </div>
  )
}
